import { useNavigate } from "react-router-dom";
import Logo from '../../Assets/images/logo.png';
import Banner from '../../Assets/images/banner.jpg';
function Signup({ setIsLoggedIn }){
    const navigate = useNavigate();
    const dirPath = process.env.REACT_APP_SUB_DIR;
    
    const handleLogin = () => {
        navigate("/login");
    };

return (
 
    <>
    
    <main className="d-flex align-items-center bg-white"  style={{background:` url(${Banner}) left center no-repeat` , backgroundSize: 'cover'}}>
        <section className="el-login-sec w-100">
            <div className=" ml-auto d-block   ">
                <div className="el-login-background d-block box-shadow-none  ">
                    <div className="el-login-card  ml-lg-auto d-block  ">
                        <div className="el-login-logo">
                            <img src="./images/logo.png" className="img-fluid  logindonar-x-logo " alt="Donor x logo"/>
                        </div>
                      
                        <h3 className="mb-3">Register your account</h3>
                        <p>Welcome to Donor x, please put your personal details below to start using the app </p>
                        <div className="el-login-form">
                            <div className="row">
                                <div className="el-form-group mb-3 col-md-6">
                                    <label htmlFor="username" className="form-label">First name<span className="text-red">*</span></label>
                                    <input type="text" placeholder="Enter First name " className="form-control " id="username "/>
                                </div>
                                <div className="el-form-group mb-3 col-md-6 ">
                                    <label htmlFor="Lastname " className="form-label ">Last name<span className="text-red ">*</span></label>
                                    <input type="Lastname " className="form-control " placeholder="Enter Last Name " id="Lastname"/>
                                </div>
                                <div className="el-form-group mb-3 col-md-12 ">
                                    <label htmlFor="Email " className="form-label ">Email <span className="text-red ">*</span></label>
                                    <input type="Email " className="form-control " placeholder="Enter Email " id="Email"/>
                                </div>
                                <div className="el-form-group mb-3 col-md-12 ">
                                    <label htmlFor="Phoneno " className="form-label ">Phone no<span className="text-red ">*</span></label>
                                    <input type="Phoneno " className="form-control " placeholder="Enter Phone no " id="Phoneno"/>
                                </div>

                                <div className="el-form-group mb-3 col-md-6">
                                    <label htmlFor="username" className="form-label">Password<span className="text-red">*</span></label>
                                    <input type="password" placeholder="Enter Password" className="form-control " id="EnterPassword "/>
                                </div>
                                <div className="el-form-group mb-3 col-md-6">
                                    <label htmlFor="username" className="form-label">Confirm Password<span className="text-red">*</span></label>
                                    <input type="password" placeholder="Confirm your  Password " className="form-control " id="EnterConfirmPassword "/>
                                </div>
                            </div>
                            <div className="el-form-btn-submit ">
                                <a href="# " className=" el-btn-primary ">Register Now </a>
                            </div>
                            <div className="el-form-link text-center ">
                                Do you have an account? <b> <a onClick={()=>{handleLogin()}} className="elfotget-password el-text-dark ">Log in  </a></b>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    </>
);
}

export default Signup;